<template>
  <!-- eg.    <template slot-scope="{item}">
          {{item.name}}padding-top:3px;
          <el-tag type="info">{{item.loc_name}}</el-tag>
  </template>-->
  <div v-loading="!ready" style="display:flex;">
    <!-- <p>{{prefixField}}::{{selectedOption}}</p> -->
    <el-select
      :disabled="disabled"
      :class="{prefixed:prefixField,largefit:large}"
      :placeholder="placeholder"
      v-model="cvalue"
      ref="sselector"
      automatic-dropdown
      style="flex:1"
      :allow-create="allowCreate"
      :filterable="filterable"
      :clearable="clearable"
      :multiple="multiple"
      :remote-method="remoteSearch"
      remote
      @clear="remoteSearch()"
      :loading="loading"
      @change="refocus"
      @visible-change="e=>e&&remoteSearch()"
    >
      <template slot="prefix" v-if="prefixField&&!hidePrefix">
        <el-tag
          style="right:-10px;"
          v-if="selectedOption&&selectedOption[prefixField]"
        >{{selectedOption[prefixField]}}</el-tag>
      </template>
      <el-option
        v-for="item in loadedOptions"
        :key="item[valueProp]"
        :label="item[labelProp]"
        :value="item[valueProp]"
      >
        <slot v-bind:item="item"></slot>
      </el-option>
    </el-select>

    <template v-if="editOptionComponentIs">
      <el-button @click="editOption()" type="text" style="flex:1">
        <fa v-if="cvalue" icon="pen" fixed-width size="lg"></fa>
        <fa v-else icon="plus" fixed-width size="lg"></fa>
      </el-button>
      <el-dialog
        append-to-body
        :title="modalTitle"
        :visible.sync="editorDialogVisible"
        width="30%"
        xbefore-close="handleEditorClose"
      >
        <component
          v-if="editOptionComponentIs"
          :is="editOptionComponentIs"
          v-bind="editOptionComponentProps"
          v-model="selectedOption"
          @change="updateOption"
          @delete="updateOption"
          @cancel="editorDialogVisible=false"
        ></component>
      </el-dialog>
    </template>
  </div>
</template>

<script>
// import mdl from "~/mixins/mdl";
import { mapActions, mapGetters } from "vuex";
import * as api from "~/api/resource";
import _ from "lodash";
export default {
  name: "s-el-remote-select",
  data() {
    return {
      hidePrefix: false,
      cvalue: null,
      cachedRemoteQ: null,
      ready: false,
      loading: false,
      loadedOptions: [],
      selectedOption: {},
      editorDialogVisible: false
    };
  },
  props: {
    sortField: { type: String, default: null },
    prefixField: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    autoSelectOne: { type: Boolean, default: false },
    loadRepo: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    viewMode: { type: Boolean, default: false },
    editOptionComponentIs: { type: String, default: null },
    editOptionComponentProps: { type: Object, default: () => null },
    focusthis: { default: false },
    filterable: { default: true },
    clearable: { default: true },
    multiple: { default: false },
    newOptionProps: { type: Object, default: () => null },
    remoteValueSelector: { type: Object, default: () => null },
    allowCreate: { type: Boolean, default: false },
    // ref: { default: null },
    options: { default: null },
    value: { default: null },
    queryProp: { type: String, default: "search" },
    extraQueryParams: { type: Object, default: () => {} },
    classModel: { type: String, default: null },
    placeholder: { type: String, default: "..." },
    labelProp: { type: String, default: "name" },
    valueProp: { type: String, default: "id" }
  },
  watch: {
    extraQueryParams: {
      handler: function(newValue) {
        const qStamp = JSON.stringify(newValue);
        if (qStamp != this.cachedRemoteQ) {
          this.cachedRemoteQ = qStamp;
          this.remoteSearch();
        }
      },
      deep: true
    },
    async value(v, vo) {
      _log_("vhann....", v, vo);
      if (v != vo && v + "" != this.cvalue + "") {
        await this.displayOption(v);
        this.hidePrefix = false;
      }
    },
    cvalue: function(val, oldval) {
      if (!oldval && val + "" == this.value + "") {
        if (this.selectedOption)
          this.$emit("change-option-data", this.selectedOption);
        return;
      }
      if (val != oldval) {
        var qo = {};
        qo[this.valueProp] = val;
        this.selectedOption = this.findInArray(this.loadedOptions, qo);
        this.hidePrefix = false;
        this.$emit("input", val);
        this.$emit("change", { val: val, oldval: oldval });
        this.$emit("change-option-data", this.selectedOption);
      } //{val:val,oldval:oldval})
    }
  },
  computed: {
    modalTitle() {
      var t = "Edit:";
      t +=
        this.selectedOption && this.selectedOption[this.valueProp]
          ? this.selectedOption[this.valueProp]
          : "option";
      return t;
    },
    ...mapGetters({
      getList: "tags/getList"
    }),
    // selectOptions() {
    //   if (this.optionsRepo) {
    //     const r = this.getList(this.optionsRepo);
    //     if (this.valueProp == "raw") {
    //       var rr = [];
    //       r.forEach(element => {
    //         rr.push({ label: element, raw: element });
    //       });
    //       return rr;
    //     }
    //     _log_("change options????" + this.optionsRepo, r);
    //     return r;
    //   }
    //   _log_("change options????", this.options);
    //   return this.options;
    // },
    selectedOptions() {
      _log_("find sel." + this.cvalue, this.optionsRepo);
      if (!this.cvalue || this.cvalue == "" || this.cvalue == 0)
        return "&nbsp;";
      if (this.valueProp == "raw") return this.cvalue;
      var avOptions = null;
      if (this.optionsRepo) {
        avOptions = this.getList(this.optionsRepo);
      }
      // THEDC.repoDB[this.optionsRepo];
      else avOptions = this.options;
      // _log_("find sel."+this.optionsRepo, avOptions,q);
      var q = {};
      q[this.valueProp] = this.cvalue + "";
      var o = _.find(avOptions, q);
      if (o) return o[this.labelProp];
      else {
        q[this.valueProp] = this.cvalue;
        o = _.find(avOptions, q);
        if (o) return o[this.labelProp];
      }
      return "?" + this.cvalue;
    }
  },
  async created() {
    // _log_("change sel.", this.optionsRepo);
    // if (this.optionsRepo && this.loadRepo) {
    //   const r = await this.fetch(this.optionsRepo);
    // }
    // // await this.remoteSearch();
    // if (this.value) this.cvalue = this.value + "";
    // _log_("CREATE sel.", this.cvalue);
  },
  methods: {
    async updateOption(v) {
      if (!v) {
        //removed
        this.cvalue = null;
        this.selectedOption = null;
        this.editorDialogVisible = false;
        return;
      }
      // _log_("success sel.", v);
      var qo = {};
      qo[this.valueProp] = v[this.valueProp];
      if (!this.findInArray(this.loadedOptions, qo)) {
        v = await api.fetchObject(this.classModel, qo);

        this.loadedOptions.push(v);
        this.stringifyProp(this.loadedOptions, this.valueProp);
      } else this.updateArray(this.loadedOptions, qo, v);
      this.cvalue = v[this.valueProp];
      this.editorDialogVisible = false;
    },
    editOption() {
      _log_(
        "change sel.",
        this.cvalue,
        this.selectedOption,
        this.newOptionProps
      );
      this.selectedOption = this.cvalue
        ? this.selectedOption
        : this.newOptionProps;
      this.editorDialogVisible = true;
    },
    handleEditorClose() {},
    createOption() {
      this.editOptionRoute();
      this.editorDialogVisible = true;
    },
    async remoteSearch(q) {
      this.loading = true;
      var goQ = { ...this.extraQueryParams };
      goQ[this.queryProp] = q ? q : "";
      const vm = this;
      _log_("is ins..SEARCH.", this.classModel, goQ);
      this.loadedOptions = await api.getModxList(this.classModel, goQ);
      if (this.sortField)
        this.loadedOptions.sort((a, b) => a[vm.sortField] - b[vm.sortField]);

      if (q) this.hidePrefix = true;
      this.loadedOptions = this.loadedOptions ? this.loadedOptions : [];

      // _log_("is ins..F.", goQ, this.loadedOptions);
      this.stringifyProp(this.loadedOptions, this.valueProp);
      if (
        this.autoSelectOne &&
        this.loadedOptions.length == 1 &&
        !this.cvalue
      ) {
        this.cvalue = this.loadedOptions[0][this.valueProp];
      }
      this.loading = false;
    },
    async displayOption(v) {
      this.loading = true;
      v = v ? v : this.value;
      _log_("go for opts", this.cvalue, v);
      if (!v) {
        //lets try to get it with alternative query
        if (this.remoteValueSelector) {
          const o = await api.fetchObject(
            this.classModel,
            this.remoteValueSelector
          );
          if (o) {
            this.selectedOption = o;
            this.loadedOptions.push(o);
            _log_(
              "go for op1111ts",
              this.loadedOptions,
              this.selectedOption,
              o
            );
            this.stringifyProp(this.loadedOptions, this.valueProp);
          }
        }
        this.$nextTick(() => {
          this.cvalue = v ? "" + v : null;
        });

        this.loading = false;
        return;
      }
      if (v === 0) v = null;

      var qo = {};
      qo[this.valueProp] = v;
      _log_("go for opts?", this.classModel, qo);
      if (!this.findInArray(this.loadedOptions, qo)) {
        const o = await api.fetchObject(this.classModel, qo);
        if (!o) {
          this.$notify.error({
            title: "Something is miising",
            message: "there is a missing option"+JSON.stringify(qo)
          });
          return;
        }
        this.selectedOption = o;
        _log_("go for opts?3333GOOO..", this.loadedOptions, o);
        qo[this.valueProp] = o[this.valueProp];
        if (!this.findInArray(this.loadedOptions, qo))
          //second check cause to async issues
          this.loadedOptions.push(o);
        this.stringifyProp(this.loadedOptions, this.valueProp);
      }
      this.$nextTick(() => {
        this.cvalue = v ? "" + v : null;
      });
      this.loading = false;
    },
    ...mapActions({
      fetch: "tags/fetch",
      fetchAllOptions: "tags/fetchAll"
    }),
    refocus() {
      var vm = this;

      let elel = this.$el; // vm.$refs['sselector']
      // if (elel) elel[0].focus()
      // _log_("change sel.", elel);
      //  elel.focus();
      let inputs = elel.getElementsByTagName("input");
      // let elel = vm.$refs['col_input' + rowScope.column.property]
      // // if (elel) elel[0].focus()
      // _log_('is ins..F.' + colIndex, elel[0])
      inputs[0].focus();
    }
  },
  async mounted() {
    var vm = this;
    try {
      await this.displayOption();
    } catch (error) {
      console.error(error);
      this.$notify.error({
        title: "Something is miising",
        message: "there is a missing option!!"
      });
    }

    // await this.displayOption();
    // if (!this.getList(this.optionsRepo))
    //   await this.fetchAllOptions([this.optionsRepo]);
    // _log_("find sel..SO.", this.getList(this.optionsRepo));
    if (this.focusthis) {
      this.$nextTick(() => {
        let elel = vm.$refs["sselector"];
        // if (elel) elel[0].focus()
        // _log_("is insCCC..F.", elel);
        elel.focus();
        let inputs = elel.$el.getElementsByTagName("input");
        // let elel = vm.$refs['col_input' + rowScope.column.property]
        // // if (elel) elel[0].focus()
        // _log_('is ins..F.' + colIndex, elel[0])
        inputs[0].focus();
      });
    }
    // _log_("is ins.MOUN.F." + this.cvalue);
    // if (!this.cvalue) await this.remoteSearch();
    // else {
    //   var qo = {};
    //   qo[this.valueProp] = this.cvalue;
    //   this.selectedOption = this.findInArray(this.loadedOptions, qo);
    // }
    this.ready = true;
  }
};
</script>

<style>
.largefit .el-input__inner {
  height: auto !important;
  line-height: 42px !important;
}
.largefit .el-input--suffix .el-input__inner {
  padding-right: auto !important;
}
.el-select.prefixed span.el-input__prefix {
  right: 0px;
}
</style>
